<template>
    <div class="w-full flex flex-column gap-3
        xl:flex-row lg:flex-row md:flex-row
        mb-0 xl:mb-6 lg:mb-6 md:mb-5">
        <MobMenu :items=[]>
            <template v-slot:body>
                <div class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:50px" @click="go_tg">
                    <div class="flex mr-3 align-items-center">
                        <Avatar class="text-600" size="small" icon="pi pi-telegram" shape="circle"/>
                    </div>
                    <div class="flex flex-1 justify-content-left align-items-center">
                        <span class="text-600">@pw_origin_bot</span>
                    </div>
                    <div class="flex justify-content-right align-items-center">
                        <i class="text-blue-500 ml-2 pi pi-external-link" />
                    </div>
                </div>
                <div class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:50px" @click="go_inst">
                    <div class="flex mr-3 align-items-center">
                        <Avatar class="text-600" size="small" icon="pi pi-instagram" shape="circle"/>
                    </div>
                    <div class="flex flex-1 justify-content-left align-items-center">
                        <span class="text-600">pay.wave.co</span>
                    </div>
                    <div class="flex justify-content-right align-items-center">
                        <i class="text-blue-500 ml-2 pi pi-external-link" />
                    </div>
                </div>
            </template>
        </MobMenu>
    </div>
</template>


<script>
import Connect  from '@/assets/js/Connect.js'
import Helper   from '@/assets/js/Helper.js'
import Event    from '@/assets/js/Event.js'
import MobMenu  from '@/components/sides/menu/MobMenu.vue' 

export default {
    data() {
        return {

        }
    },
    components: {
        MobMenu,
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
    },
    methods: {
        go_tg(){
            this.event.send('linkTg')
            window.open('https://t.me/pw_origin_bot', '_blank')
        },
        go_inst(){
            this.event.send('linkInst')
            window.open('https://www.instagram.com/pay.wave.co/', '_blank')
        },
        copy(text){
            this.helper.copy_clipboard(text)
            let title = (this.lang_=='ru') ? 'Скопировано' : 'Copied'
            this.showMess('success', title, text)
        },
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
        this.event = new Event()
    },
}
</script>